import React from "react";
import { Box } from "@mui/material";
import CInput from "../CInput";
import CAutocomplete from "../CAutocomplete";
import CDatePicker from "../CDatePicker";
import PlaceAutoComplete from "../PlaceAutoComplete";

const ProjectForm = ({ 
  formData, 
  errors, 
  onInputChange, 
  onErrorClear,
  editingProject 
}) => {
  const unitTypeOptions = [
    "Apartment",
    "Villa", 
    "AirBnB",
    "Landscape",
    "Comercial",
    "Retail"
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Project Name and Unit Type Row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', paddingTop: 1 }}>
        <Box sx={{ flex: '0 0 70%' }}>
          <CInput
            label="Project Name"
            value={formData.title}
            onChange={(e) => {
              onInputChange('title', e.target.value);
              if (e.target.value && errors.titleErr) {
                onErrorClear('title');
              }
            }}
            error={errors.titleErr}
            helpertext={errors.titleMsg}
            required
            placeholder="Enter project name"
          />
        </Box>
        <Box sx={{ flex: '0 0 25%', width: '25%' }}>
          <CAutocomplete
            label="Unit Type"
            options={unitTypeOptions}
            value={formData.unitType || null}
            onChange={(event, newValue) => {
              onInputChange('unitType', newValue || '');
              if (newValue && errors.unitTypeErr) {
                onErrorClear('unitType');
              }
            }}
            placeholder="Select unit type"
            error={errors.unitTypeErr}
            helpertext={errors.unitTypeMsg}
            required
          />
        </Box>
      </Box>

      {/* Location and Date Row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ flex: '0 0 70%' }}>
          <PlaceAutoComplete
            key={`location-${editingProject?.id || 'new'}`}
            placeholder="Enter project location (optional)"
            onChange={(locationObj) => {
              onInputChange('location', locationObj?.location || '');
              if (locationObj?.location && errors.locationErr) {
                onErrorClear('location');
              }
            }}
            defaultValue={formData.location}
            error={errors.locationErr}
            helperText={errors.locationMsg}
          />
        </Box>
        <Box sx={{ flex: '0 0 25%', width: '25%', minWidth: 0, position: 'relative' }}>
          <CDatePicker
            label="Project End Date"
            value={formData.projectDate}
            onChange={(newValue) => {
              onInputChange('projectDate', newValue);
              if (newValue && errors.dateErr) {
                onErrorClear('date');
              }
            }}
            error={errors.dateErr}
            helperText={errors.dateMsg}
            isProjectUpdate={!!editingProject}
            allowPastDates={true}
          />
        </Box>
      </Box>

      {/* Description - Full Width */}
      <CInput
        label="Description"
        value={formData.description}
        onChange={(e) => onInputChange('description', e.target.value)}
        multiline
        rows={3}
        placeholder="Summarize your project"
      />
    </Box>
  );
};

export default ProjectForm;
